import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { AuthForm } from '../components/auth/AuthForm';
export function AuthPage() {
  const [mode, setMode] = useState<'login' | 'register' | 'forgot'>('login');
  const navigate = useNavigate();
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate('/area-usuario', {
        replace: true
      });
    }
  }, [isAuthenticated, isLoading, navigate]);
  if (isLoading) {
    return <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center" data-id="element-800">
        <Loader2 className="w-8 h-8 text-gold animate-spin" data-id="element-801" />
      </div>;
  }
  const getTitle = () => {
    if (mode === 'forgot') return 'Recupera tu contraseña';
    if (mode === 'register') return 'Crea tu cuenta';
    return 'Accede a tu espacio de transformación';
  };
  const getSubtitle = () => {
    if (mode === 'forgot') return 'Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.';
    if (mode === 'register') return 'Comienza tu viaje hacia la abundancia y claridad.';
    return 'Un espacio para reconectar contigo, calmar tu mente y enfocarte en lo que realmente importa.';
  };
  return <div className="min-h-screen bg-[#0A0A0B] font-sans text-white selection:bg-gold/30 selection:text-gold flex flex-col relative overflow-hidden" data-id="element-802">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0 pointer-events-none" data-id="element-803">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-gold/5 rounded-full blur-[120px]" data-id="element-804" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-gold/5 rounded-full blur-[120px]" data-id="element-805" />
      </div>

      {/* Header */}
      <header className="relative z-10 p-6 sm:p-8 flex items-center justify-between" data-id="element-806">
        <button onClick={() => mode === 'forgot' ? setMode('login') : navigate('/')} className="flex items-center gap-2 text-white/60 hover:text-gold transition-colors text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-807">
          <ArrowLeft className="w-4 h-4" data-id="element-808" />
          {mode === 'forgot' ? 'Volver al login' : 'Volver'}
        </button>
        <div className="font-serif italic text-gold text-lg sm:text-xl font-bold tracking-[2px]" data-id="element-809">
          EL CÓDIGO 888
        </div>
        <div className="w-20" data-id="element-810" />
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4 sm:p-6 relative z-10" data-id="element-811">
        <div className="w-full max-w-[420px]" data-id="element-812">
          <div className="text-center mb-8" data-id="element-813">
            <h1 className="font-serif text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-814">
              {getTitle()}
            </h1>
            <p className="text-white/60 text-sm" data-id="element-815">{getSubtitle()}</p>
          </div>

          <AuthForm mode={mode} switchMode={setMode} data-id="element-816" />
        </div>
      </main>
    </div>;
}